import React, {useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

const MainLayout = (props) => {

    let navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);

    useEffect(() => {
                if (userdata && Object.keys(userdata).length > 0) {
                  //   fetchdata();
                  
                } else {
                  navigate("/login");
                }
              }, []);
    return (
       <div className="mainlayout-maindiv">
            <div className="mainlayout-leftdiv">
                <Sidebar />
            </div>
            <div className="mainlayout-rightdiv">
                <div className="mainlayout-navbar">
                    <Navbar title={props?.title} />
                </div>
                <div className="mainpage">
                    {props.children}
                </div>
            </div>
       </div>
    )
}

export default MainLayout